import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public getToken: any;

  public userName: any;
  constructor() { }

  ngOnInit(): void {
    this.getToken = (localStorage.getItem('token'))
    this.userName = JSON.parse(this.getToken);
  }
  
}



